import { render, staticRenderFns } from "./Template-02.vue?vue&type=template&id=3bbfc44e&scoped=true&"
import script from "./Template-02.vue?vue&type=script&lang=js&"
export * from "./Template-02.vue?vue&type=script&lang=js&"
import style0 from "./Template-02.vue?vue&type=style&index=0&id=3bbfc44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfc44e",
  null
  
)

export default component.exports